<template>
    <div class="movie-wrapper">
        <!-- 图片 -->
        <div class="movie-box">
            <div class="acea-row row-middle img-box" :style="imgStyle">
                <img class="page-image1" :src="titleInfo"/>
            </div>
            <!-- list -->
            <div v-if="pinjie" class="movie-box" :style="topImageStyle"></div>
            <ul class="movie-box" :style="listStyle">
                <div class="movie-box acea-row" :style="listWrapStyle">
                    <li class="card-wrapper" :style="cardStyle" v-for="(item, ind) in list" :key="ind">
                        <div class="movie-box page-background-color-white a-wrapper" :style="cardOne" @click="goToDetail(item.id)">
                            <img class="page-image1 img-top" :style="cardOneImageStyle" v-lazy="item.image" />
                            <dl class="movie-box pad20">
                                <dt :style="bottomPrice.dt" class="line1 text">{{item.title}}</dt>
                                <dd :style="bottomPrice.dd" class="font-color-red acea-row row-between price">
                                    <div :style="bottomPrice.wrapStyle">
                                        <span :style="bottomPrice.front" class="page-display-none">￥</span>
                                        <span :style="bottomPrice.priceStyle">{{item.price}}</span><i :style="bottomPrice.iconStyle" class="icon-money"></i>
                                    </div>
                                    <img class="jiagou" :style="bottomPrice.imgStyle" :src="bottomPrice.src?bottomPrice.src:require('@assets/images/jiagou.png')" />
                                </dd>
                            </dl>
                        </div>
                    </li>
                </div>
            </ul>
            <div v-if="pinjie" class="movie-box" :style="bottomImageStyle"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FestivalModul",
    props: {
        pinjie: { //是否为拼接背景图片
            type: Boolean,
            default: false
        },
        festivalName: {
            type: Number,
            default: null
        },
        bottomImageStyle: {
            type: Object,
            default: ()=>{}
        },
        topImageStyle: {
            type: Object,
            default: ()=>{}
        },
        imgStyle: {
            type: Object,
            default: ()=>{}
        },
        listStyle: {
            type: Object,
            default: ()=>{}
        },
        listWrapStyle: {
            type: Object,
            default: ()=>{}
        },
        cardStyle: {
            type: Object,
            default: ()=>{}
        },
        titleInfo: {
            type: String,
            default: ""
        },
        cardOne: {
            type: Object,
            default: ()=>{}
        },
        cardOneImageStyle: {
            type: Object,
            default: ()=>{}
        },
        bottomPrice: {
            type: Object,
            default: function () {
                return {
                    priceStyle: {},
                    imgStyle: {},
                    iconStyle: {},
                    src: `${require('@assets/images/jiagou.png')}`,
                    wrapStyle: {},
                    front: {},
                    dd: {},
                    dt: {}
                }
            }
        },
        list: {
            type: Array,
            default: ()=>[]
        }
    },
    data: function () {
        return {
            // titleInfo: "",
            // list: [
            //     {
            //         image: "",
            //         title: "",
            //         price: ,
            //         id: 
            //     }
            // ]
        }
    },
    methods: {
        goToDetail: function (id) {
            this.$router.push({path: `/detail/${id}`, query: { 'festivalName': this.festivalName}});
        }
    }
}
</script>

<style scoped>
.img-box {
    margin: .4rem 0;
    height: 2.76rem;
}
.a-wrapper {
    border-radius: .1rem;
}
.card-wrapper {
    width: 50%;
    box-sizing: border-box;
    padding: .1rem;
    /* height: 4.8rem; 手机型号不兼容*/
    min-height: 4.8rem;
}
.img-top {
    box-sizing: border-box;
    padding: .2rem;
}
.text {
    color: #666;
    min-height: .66rem;
    font-size: .24rem;
    text-align: left;
}
.price {
    padding: 0 0 .2rem;
    margin-top: 5px;
    font-size: .28rem;
    font-weight: 800;
}
.icon-money {
    display: inline-block;
    width: 0.34rem;
    height: 0.34rem;
    background: url('../assets/images/icon-money.png') no-repeat center;
    background-size: 100% 100%;
    margin-left: .03rem;
    margin-bottom: -0.08rem;
}
.jiagou {
    width: 0.31rem;
    height: 0.31rem;
    display: inline-block;
}
</style>